import React from "react";
import { Button, Textarea } from "@chakra-ui/react";
import { useAuth } from "hooks/auth";
import { uploadFile, uploadImg, useAddNote } from "hooks/notes";
import { useForm } from "react-hook-form";
import TextareaAutosize from "react-textarea-autosize";
import "stylesheets/MainAppStyles/NewNote.css";
import "stylesheets/MainAppStyles/BarActions.css";
import { faImage } from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import NoteFile from "./NoteFile";
import { useState } from "react";
import TagsInput from "./TagsInput";
import { useEffect } from "react";

const NewNote = () => {
    const { register, handleSubmit, reset, setValue } = useForm();
    const { addNote, isLoading: addingNote } = useAddNote();
    const { user, isLoading: authLoading } = useAuth();
    const [loadedFiles, setLoadedFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [isEditing, setIsEditing] = useState(true);
    const [isImgUploading, setIsImgUploading] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState("");
    const noteContent = register("text", { required: true });

    async function handleAddPost(data) {
        const blob = new Blob([data.text.replace(/#(?! )/g, "# ")], {
            type: "text/markdown;charset=utf-8",
        });
        const file = new File([blob], "note.md", { type: "text/markdown" });
        addNote({
            uid: user.id,
            title: data.title,
            text: file,
            loadedFiles: loadedFiles,
            tags: tags,
        });
        reset();
    }

    const handleImageUpload = async (e) => {
        setIsImgUploading(true)
        const url = await uploadImg(e.target.files[0]);
        const newTextAreaValue = textAreaValue + `\n![${e.target.files[0].name}](${url})`;
        setTextAreaValue(newTextAreaValue);
        setValue("text", newTextAreaValue);
        setIsImgUploading(false);
    };

    useEffect(()=>{
        isImgUploading ? setIsEditing(true) : setIsEditing(false)
    },[isImgUploading])

    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) {
            return;
        }
        const { downloadURL, id, name, ext } = await uploadFile(file);
        setLoadedFiles([...loadedFiles, { url: downloadURL, id, name, ext }]);
    };

    const handleTextAreaChange = (event) => {
        const value = event.target.value;
        setTextAreaValue(value);
    };

    useEffect(()=>{
        console.log(textAreaValue);
    },[textAreaValue])

    return (
        <div className="post-form-main-container">
            <form
                className="post-form-container"
                onSubmit={handleSubmit(handleAddPost)}
            >
                <Textarea
                    className="input-title"
                    as={TextareaAutosize}
                    resize="none"
                    placeholder="Note title here..."
                    variant="unstyled"
                    minH="none"
                    {...register("title", { required: true })}
                />
                <div className="uploaded-files-container">
                    {loadedFiles.length !== 0 &&
                        loadedFiles.map((file) => (
                            <NoteFile
                                loadedFiles={loadedFiles}
                                setLoadedFiles={setLoadedFiles}
                                id={file.id}
                                ext={file.ext}
                                filePath={file.url}
                                key={file.id}
                                fileName={file.name}
                            />
                        ))}
                </div>
                <TagsInput tags={tags} setTags={setTags} />
                <Textarea
                    className="input-content"
                    as={TextareaAutosize}
                    value={textAreaValue}
                    resize="none"
                    placeholder="Write your content here..."
                    variant="unstyled"
                    minRows="8"
                    {...register("text", { 
                        required: true,
                        onChange: handleTextAreaChange
                    })}
                />
                <div className="bar-actions-container">
                    <input
                        accept="image/*"
                        type="file"
                        id="image-upload"
                        onChange={handleImageUpload}
                        hidden
                    />
                    <label htmlFor="image-upload" className="image-upload">
                        <FontAwesomeIcon icon={faImage} />
                    </label>
                    <input
                        accept=".xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,.js,.html,.css"
                        type="file"
                        id="doc-upload"
                        onChange={handleFileUpload}
                        hidden
                    />
                    <label htmlFor="doc-upload" className="image-upload">
                        <FontAwesomeIcon icon={faPaperclip} />
                    </label>
                </div>
                <Button
                    colorScheme="teal"
                    type="submit"
                    isLoading={authLoading || addingNote}
                    isDisabled={isEditing ? true : false}
                    loadingText="Posting"
                >
                    Post
                </Button>
            </form>
        </div>
    );
};

export default NewNote;
